import INoteContentBuilder from "../types/INoteContentBuilder";
import NoteTags from "../types/NoteTags";
import TagSeriesNoteContentBuilder from "../types/TagSeriesNoteContentBuilder";

const patientNoteTags = [
  NoteTags.serviceSubCategoryName,
  NoteTags.obxTag,
  NoteTags.businessUnitTag,
  NoteTags.patientHeightWeightBmiTag,
  NoteTags.patientDateOfBirthNoteTag,
  NoteTags.patientMedicalQualificationPassFailNoteTag,
  NoteTags.patientDistanceToCenterNoteTag,
  NoteTags.centerNameNoteTag,
  NoteTags.disqualifyingReasonsNoteTag,
  NoteTags.diabetesNoteTag,
  NoteTags.radiationProtectedAreasNoteTag,
  NoteTags.pacemakerWithoutDefibrillatorNoteTag
];

/** The union of props needed to build all tags in {@link PatientNoteContentBuilder}.
 * @remarks This type looks ugly, but is the only feasible way of building this type organically.
 */
export type PatientNoteTagProps = (typeof patientNoteTags)[number] extends {
  buildTagContent: (props: infer P) => unknown;
}
  ? P
  : never;

/** The composed {@link INoteContentBuilder} for building patient notes. */
const PatientNoteContentBuilder: INoteContentBuilder<PatientNoteTagProps> =
  new TagSeriesNoteContentBuilder<PatientNoteTagProps>(patientNoteTags, " / ");

export default PatientNoteContentBuilder;
